export class UserGroupMemberListItemModel {
  public id: string;
  public userName: string;
  public userId: string;
}
